import { ChartWrapper } from "charts/src/components/chart";
import { ChartComponentParams } from "charts/src/types/chart";
import { Suspense } from "react";

const ReplyChartView = ({
  chartParamsList,
}: {
  chartParamsList: ChartComponentParams[];
}) => (
  <div className="flex w-full flex-col items-center gap-2">
    <Suspense>
      {chartParamsList.map((props, index) => (
        <ChartWrapper key={index} {...props} />
      ))}
    </Suspense>
  </div>
);

export default ReplyChartView;
